<div class="genie-page">
  <form (ngSubmit)="onSubmit(f)" #f="ngForm">
    <!-- Page Header -->
    <div class="genie-page-header">
      <div class="header-left">
        <div class="backButton" (click)="builderService.navigateBack()">
          <img src="/assets/icons/arrow-left.svg" [alt]="'Go back' | translate" />
        </div>
        <div class="header-title-group">
          <p class="genie-page-title">{{ 'Add New User' | translate }}</p>
          <p class="genie-page-subtitle">{{ 'Add new user and manage his information' | translate }}</p>
        </div>
      </div>
      <div class="header-right">
        <button class="genie-btn danger" type="button" [routerLink]="['/users']" *ngIf="editPage">{{ 'Delete' | translate }}</button>
        <button class="genie-btn primary" type="submit">
          <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.36589 0.699219V10.0326M0.699219 5.36589H10.0326" stroke="white" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          {{ 'Add New User' | translate }}
        </button>
      </div>
    </div>

    <!-- User Info Card -->
    <div class="section-card">
      <div class="card-header">
        <h3>{{ 'User Info' | translate }}</h3>
      </div>
      <div class="card-body">

        <!-- Row 1: First Name + Last Name -->
        <div class="fields-grid-row">
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'First Name' | translate }}</label>
            </div>
            <div class="genie-input" [class.invalid]="firstNameInput.invalid && (firstNameInput.touched || f.submitted)">
              <input required name="firstName" [(ngModel)]="user.firstName" #firstNameInput="ngModel" placeholder="{{ 'First Name' | translate }}" />
            </div>
            <div class="error-message" *ngIf="firstNameInput.invalid && (firstNameInput.touched || f.submitted)">
              {{ 'First Name is required.' | translate }}
            </div>
          </div>
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Last Name' | translate }}</label>
            </div>
            <div class="genie-input" [class.invalid]="lastNameInput.invalid && (lastNameInput.touched || f.submitted)">
              <input required name="lastName" [(ngModel)]="user.lastName" #lastNameInput="ngModel" placeholder="{{ 'Last Name' | translate }}" />
            </div>
            <div class="error-message" *ngIf="lastNameInput.invalid && (lastNameInput.touched || f.submitted)">
              {{ 'Last Name is required.' | translate }}
            </div>
          </div>
        </div>

        <!-- Row 2: Email Address + Phone Number -->
        <div class="fields-grid-row">
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Email Address' | translate }}</label>
            </div>
            <div class="genie-input" [class.invalid]="emailInput.invalid && (emailInput.touched || f.submitted)">
              <input required name="emailAddress" [(ngModel)]="user.emailAddress" #emailInput="ngModel" [placeholder]="'example@gmail.com' | translate" />
            </div>
            <div class="error-message" *ngIf="emailInput.invalid && (emailInput.touched || f.submitted)">
              {{ 'Email Address is required.' | translate }}
            </div>
          </div>
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Phone Number' | translate }}</label>
            </div>
            <div class="genie-input" [class.invalid]="phoneInput.invalid && (phoneInput.touched || f.submitted)">
              <input required name="phoneNumber" [(ngModel)]="user.phoneNumber" #phoneInput="ngModel" placeholder="+1234567890" />
            </div>
            <div class="error-message" *ngIf="phoneInput.invalid && (phoneInput.touched || f.submitted)">
              {{ 'Phone Number is required.' | translate }}
            </div>
          </div>
        </div>

        <!-- Row 3: Password + User Role -->
        <div class="fields-grid-row">
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'Password' | translate }}</label>
            </div>
            <div class="genie-input password-field" [class.invalid]="passwordInput.invalid && (passwordInput.touched || f.submitted)">
              <input [type]="hidePassword ? 'password' : 'text'" required name="password" [(ngModel)]="user.password" #passwordInput="ngModel" placeholder="{{ 'Password' | translate }}" />
              <button class="visibility-toggle" (click)="hidePassword = !hidePassword" type="button">
                <!-- eye open -->
                <svg *ngIf="hidePassword" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.5 2.8125C4.375 2.8125 1.75625 4.80625 0.625 7.5C1.75625 10.1937 4.375 12.1875 7.5 12.1875C10.625 12.1875 13.2437 10.1937 14.375 7.5C13.2437 4.80625 10.625 2.8125 7.5 2.8125Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M7.5 9.6875C8.70812 9.6875 9.6875 8.70812 9.6875 7.5C9.6875 6.29188 8.70812 5.3125 7.5 5.3125C6.29188 5.3125 5.3125 6.29188 5.3125 7.5C5.3125 8.70812 6.29188 9.6875 7.5 9.6875Z" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <!-- eye slash -->
                <svg *ngIf="!hidePassword" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.5 2.5L12.5 12.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/>
                  <path d="M6.46 3.86A6.2 6.2 0 017.5 3.75c3.125 0 5.625 1.875 6.875 3.75a12.5 12.5 0 01-2.2 2.78" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4.5 4.94A12.5 12.5 0 00.625 7.5C1.875 9.375 4.375 11.25 7.5 11.25a6.6 6.6 0 003.07-.75" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M5.94 5.94a1.875 1.875 0 003.12 3.12" stroke="currentColor" stroke-width="1.25" stroke-linecap="round"/>
                </svg>
              </button>
            </div>
            <div class="error-message" *ngIf="passwordInput.invalid && (passwordInput.touched || f.submitted)">
              {{ 'Password is required.' | translate }}
            </div>
          </div>
          <div class="field-wrapper">
            <div class="field-label-row">
              <label>{{ 'User Role' | translate }}</label>
            </div>
            <!-- Hidden select keeps ngModel + required validation intact -->
            <select required [(ngModel)]="user.selectedRole" name="selectedRole" #selectedRoleInput="ngModel" style="display:none"></select>
            <div #roleTrigger class="genie-input custom-role-select" [class.invalid]="selectedRoleInput.invalid && (selectedRoleInput.touched || f.submitted)"
              (click)="toggleRoleDropdown($event)">
              <span [class.select-placeholder]="!user.selectedRole">
                {{ user.selectedRole ? getRoleLabel(user.selectedRole) : ('Select User Role' | translate) }}
              </span>
              <img src="/assets/icons/arrow-down.svg" width="14" height="14" alt="" class="select-arrow" [class.open]="roleDropdownOpen" />
            </div>
            <div class="role-dropdown-panel" *ngIf="roleDropdownOpen"
              (click)="$event.stopPropagation()">
              <div class="role-option" *ngFor="let opt of roleOptions" (click)="selectRole(opt.value, $event)">
                {{ opt.label | translate }}
              </div>
            </div>
            <div class="error-message" *ngIf="selectedRoleInput.invalid && (selectedRoleInput.touched || f.submitted)">
              {{ 'Please choose a user role.' | translate }}
            </div>
          </div>
        </div>

      </div>
    </div>
  </form>
</div>
